import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Crm Settings", -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-8 leading-normal"
}, "Sorry you do not have any tenant associated with your account.", -1);
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_6 = {
  "class": "w-1/2 flex"
};
var _hoisted_7 = {
  "class": "w-1/2"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  "class": "w-full p-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")], -1);
var _hoisted_9 = {
  "class": "w-full p-2"
};
var _hoisted_10 = {
  key: 0,
  "class": "card-lg bg-fwhite w-1/2 mx-auto p-2"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", {
  "class": "text-center text-3xl font-bold"
}, "Crm Config", -1);
var _hoisted_12 = {
  "class": "max-w-md mx-auto p-2"
};
var _hoisted_13 = {
  style: {
    "min-height": "50px"
  }
};
var _hoisted_14 = {
  "class": "bg-red-100 p-2 border-2 shadow-md rounded-md flex justify-between items-center mb-2"
};
var _hoisted_15 = {
  "class": "flex justify-start items-center"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  "class": "px-2"
}, [/*#__PURE__*/_createElementVNode("i", {
  "class": "fi-rs-exclamation"
})], -1);
var _hoisted_17 = {
  "class": "text-sm"
};
var _hoisted_18 = {
  "class": "flex flex-col justify-start align-top w-full gap-1"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  "for": "name",
  "class": "px-1 text-sm font-semibold text-left"
}, "Access Token", -1);
var _hoisted_20 = {
  key: 0,
  "class": "flex flex-col justify-start align-top w-full gap-1 mt-3"
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  "for": "name",
  "class": "px-1 text-sm font-semibold text-left"
}, "Owner Id", -1);
var _hoisted_22 = {
  "class": "relative"
};
var _hoisted_23 = {
  key: 1,
  "class": "flex flex-col justify-start align-top w-full gap-1 mt-3"
};
var _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  "for": "name",
  "class": "px-1 text-sm font-semibold text-left"
}, "Owner Email", -1);
var _hoisted_25 = {
  "class": "relative"
};
var _hoisted_26 = {
  "class": "flex flex-col justify-start align-top w-full gap-1 mt-3"
};
var _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  "for": "name",
  "class": "px-1 text-sm font-semibold text-left"
}, "Sync Type", -1);
var _hoisted_28 = {
  "class": "relative"
};
var _hoisted_29 = /*#__PURE__*/_createTextVNode("EMAIL ACTIVITY");
var _hoisted_30 = /*#__PURE__*/_createTextVNode("LEADS INFO");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_input = _resolveComponent("el-input");
  return $props.tenantList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Crm Settings"
  }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Head, {
    title: "Crm Settings"
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingCrmConfig,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_select, {
        modelValue: $data.tenant,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.tenant = $event;
        }),
        filterable: "",
        onChange: _cache[1] || (_cache[1] = function ($event) {
          return $options.getTenantCrmConfig();
        }),
        clearable: ""
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (t, t_key) {
            return _openBlock(), _createBlock(_component_el_option, {
              value: t.id,
              label: t.id
            }, null, 8, ["value", "label"]);
          }), 256))];
        }),
        _: 1
      }, 8, ["modelValue"])];
    }),
    _: 1
  }, 8, ["loading"])])])])]), _createVNode(_component_el_skeleton, {
    loading: $data.isLoadingCrmConfig,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [Object.keys($data.crmConfig).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString($data.errorMsg), 1)])], 512), [[_vShow, $data.errorMsg.length > 0]])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_el_input, {
        modelValue: $data.crmConfig.access_token,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $data.crmConfig.access_token = $event;
        }),
        type: "text",
        "class": "w-full",
        autocomplete: "off"
      }, null, 8, ["modelValue"])]), $data.crmConfig.owner_id.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_input, {
        modelValue: $data.crmConfig.owner_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return $data.crmConfig.owner_id = $event;
        }),
        "class": "w-full",
        disabled: ""
      }, null, 8, ["modelValue"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_input, {
        modelValue: $data.crmConfig.owner_email,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return $data.crmConfig.owner_email = $event;
        }),
        "class": "w-full"
      }, null, 8, ["modelValue"])])])), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_select, {
        modelValue: $data.crmConfig.sync,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return $data.crmConfig.sync = $event;
        }),
        multiple: "",
        "class": "w-full res-input"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_option, {
            value: "EMAIL_ACTIVITY"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_29];
            }),
            _: 1
          }), _createVNode(_component_el_option, {
            value: "LEADS_INFO"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_30];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("button", {
        "class": "btn-primary w-full mt-4",
        type: "button",
        onClick: _cache[6] || (_cache[6] = function () {
          return $options.saveConfig && $options.saveConfig.apply($options, arguments);
        })
      }, "Save Config")])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["loading"])]));
}